export const EVENT = {
  COMPLETE: "complete",
};

export const STATE = {
  INACTIVE: {
    KEY: "INACTIVE",
    VALUE: 0,
  },
  ACTIVE: {
    KEY: "ACTIVE",
    VALUE: 49,
  },
  PLAY: {
    KEY: "PLAY",
    VALUE: [1, 48],
  },
};
